/**
 * Contact form captcha: loads a new code on the refresh button and after every Contact Form 7 submit
 * (each code is valid for one attempt). Markup comes from inc/captcha.php.
 */
(function ($) {
    'use strict';

    function refresh($box) {
        var $img = $box.find('[data-captcha-image]');
        $box.addClass('is-loading');
        $.post($box.data('ajax'), { action: 'cb_captcha' })
            .done(function (res) {
                if (res && res.success) {
                    $img.attr('src', res.data.image);
                    $box.find('[data-captcha-token]').val(res.data.token);
                    $box.find('.cb-captcha__input').val('');
                }
            })
            .always(function () {
                $box.removeClass('is-loading');
            });
    }

    $(document).on('click', '[data-captcha-refresh]', function () {
        refresh($(this).closest('.cb-captcha'));
    });

    // CF7 fires these on the form element after an AJAX submit
    $(document).on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed', function (e) {
        $(e.target).find('.cb-captcha').each(function () {
            refresh($(this));
        });
    });
})(jQuery);
